<p>frame-options-product-configuration works!</p>

<div>
  <app-list-values-product-configuration></app-list-values-product-configuration>
</div>
